// Copyright (c) 2022 Celadon Development LLC, All rights reserved.
// Author Alexander Mikholap <alexander.miholap@celadon.ae>
import * as types from './actionTypes';

export function resetPage() {
  return {
    type: types.ISSUE_VOUCHER_RESET,
  };
}

export function startLoader() {
  return {
    type: types.ISSUE_VOUCHER_START_LOADER,
  };
}

export function stopLoader() {
  return {
    type: types.ISSUE_VOUCHER_STOP_LOADER,
  };
}

export function changeCustomerFields(value, field) {
  return {
    type: types.ISSUE_VOUCHER_CHANGE_CUSTOMER_FIELDS,
    value,
    field
  };
}

export function issueVoucher() {
  return {
    type: types.ISSUE_VOUCHER,
  };
}

export function validateBookshopCustomerForm() {
  return {
    type: types.VALIDATE_BOOKSHOP_CUSTOMER_FORM,
  };
}

export function setRequestStatus(status, messages) {
  return {
    type: types.SET_REQUEST_STATUS,
    status,
    messages,
  };
}

export function resetBookshopCustomerForm() {
  return {
    type: types.BOOKSHOP_CUSTOMER_RESET_FORM,
  };
}
